function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { getMuxUrlFromGCSUrl } from '../../muxUrl';
import { ContentType } from '../../types/graphql.generated';
export var OTX601_URI_BY_FILENAME = {
    'PHET_4.mp4': 'https://stream.mux.com/G014BKVSDhvRmS5BuRyVCr1aGmGLv2wbK002YExtOhbwI.m3u8',
    'PHET_5.mp4': 'https://stream.mux.com/jcK5PXZPlvcK1ihA8F1c4WP9gGmrgOoR9OdSj401IeIE.m3u8',
    'PHET_6_8.mp4': 'https://stream.mux.com/I9RRlNuPiIql2qvT3qDDNRRiRq9C1NbTJk5ijmhT2300.m3u8',
    'PHET_9.mp4': 'https://stream.mux.com/Qnd007HlQMrVRBpZ65HklM01qNBoDxNcw4mj02i7idA1Zk.m3u8',
    'PHET_10_11.mp4': 'https://stream.mux.com/9D3H00AJdXLSErk7uiuODGfosjVHWD7jDZSuqslaSPDY.m3u8',
    'PHET_12_14.mp4': 'https://stream.mux.com/ij00EBUXx1M4vEO4MbNp01X00XpVF1cR5ah1029dtLXFinY.m3u8',
    'PHET_15_16.mp4': 'https://stream.mux.com/kjRoy6Eb9dwWKlArAm2mWhycNWv00MmF00eOAeOZXjCC4.m3u8',
    'PHET_17_18.mp4': 'https://stream.mux.com/VYReWfBD5orrgQ1gAx6Ae51zbq0248xjbdxe92W00OhTs.m3u8',
    'PHET_19_21.mp4': 'https://stream.mux.com/kTlXmZQvXivtSlw3jTrzUrtKArihc01sW8VRNVONZd6k.m3u8',
    'PHET_22.mp4': 'https://stream.mux.com/CuZElgPkDc4ZJ5GB00N5SdV4OScSh3A9ddFvJaWuIbvU.m3u8',
    'PHET_23.mp4': 'https://stream.mux.com/Vh01A028G8rYTFgTctSpRuXt00sjMGioP3dZxocC79XWcg.m3u8',
    'PHET_24.mp4': 'https://stream.mux.com/J5mFhbjK01Tf0101hMyoO1Bbg5llnHCw3THbtG00ybb00krw.m3u8',
    'PHET_26_30.mp4': 'https://stream.mux.com/vL00TKVQiZ2J500MWxr02NtD700025ucvy027Q11iOqc2YL700.m3u8',
    'PHET_31_32.mp4': 'https://stream.mux.com/6hxVnS7kKp8KIiWc1VnBGLZaZj1Fxqd9XIZeV3ie002Y.m3u8',
    'PHET_33_35.mp4': 'https://stream.mux.com/6rnmPdjBXIC02g02B0200qkA5Ral01LbMuUmoCbgtZvlQjP8.m3u8',
    'PHET_36.mp4': 'https://stream.mux.com/q8S9GevkEp410255sLOQ02006e4uW2slsQZD02snemsWhjQ.m3u8',
    'PHET_37.mp4': 'https://stream.mux.com/K001dypK3jOMilJkS00KiCJe02i3S01xyBfveTRm6u76A4Q.m3u8',
    'PHET_38_40.mp4': 'https://stream.mux.com/Bf6HpOZK5agS0243500PuF3OiLpDhLbGjtD3iWAHyOSPE.m3u8',
    'PHET_41.mp4': 'https://stream.mux.com/XfbEubCOnJYHhOqyIMzXnlfUflfbN0000L2pRhjTltyGg.m3u8',
    'PHET_42_43.mp4': 'https://stream.mux.com/qWr6t01OhPdqFEAYo01gCVbs5zI6wccXpMIJzfmWAqI7Y.m3u8',
    'PHET_44.mp4': 'https://stream.mux.com/GQVcWEW902skosDPnAb01essuJoAnnFgib01sgnyogegCc.m3u8',
    'PHET_45.mp4': 'https://stream.mux.com/fIYaq8Z4sfd4S5007EeKYnW00hLkBThAcVHkYKSKQWUnc.m3u8',
    'PHET_46_47.mp4': 'https://stream.mux.com/rmDPEDAfPcO9i3n6ps8POp715XSwu600XMSsrlyk7jy4.m3u8',
    'PHET_48_51.mp4': 'https://stream.mux.com/Ld8QDpibb024XmPiHdyGxMUCO901oW02xRwH3b0002hEpKcw.m3u8',
    'PHET_52.mp4': 'https://stream.mux.com/hdpUVhJGwxC00YKscC01yhrccba6tZg5xY00EObbhlobQE.m3u8',
    'PHET_53.mp4': 'https://stream.mux.com/7KU1P00ZbbFKA018ENOC02y9N0184801XtKYpQjz3KUVuUSI.m3u8',
    'PHET_54_55.mp4': 'https://stream.mux.com/Ccnq4MXTrba401TYsXlokz004CAzrLzcKtBkVs8k1emcY.m3u8',
    'PHET_56.mp4': 'https://stream.mux.com/zJOWnJRB2024JzYtvX300urx1YHuGnVZaH8502tbv8umSg.m3u8',
    'PHET_57_58.mp4': 'https://stream.mux.com/gI0183oJAk4dVBIq3L119FWDiNiFZRXnAdKcDGJR67GM.m3u8',
    'PHET_59.mp4': 'https://stream.mux.com/ZJPYZOEUI344Tim6Jj602MNyomb8dQELJM7gYwEba3I4.m3u8',
    'PHET_60.mp4': 'https://stream.mux.com/DH7EFjiPD02YO2JDVZ59BqVd8200YKD4te9QK2zKC1XZQ.m3u8',
    'PHET_61.mp4': 'https://stream.mux.com/017cBK00ay500xWdQMfjQ2QCS3t34uGZZx89tF652k26WQ.m3u8',
    'PHET_62_63.mp4': 'https://stream.mux.com/LkitByajGa3TdfnHaJzwukEx3fKtC94h00BE3XqX00wNQ.m3u8',
    'PHET_64.mp4': 'https://stream.mux.com/02cOGlxWwY201IPCvNv01tZS3LnMP1PYVxD7JR5B5AMvKs.m3u8',
    'PHET_65_66.mp4': 'https://stream.mux.com/INRa6zN2A9b00szw00Yhj2z6n01Ms1tkrniPMWacefacX00.m3u8',
    'PHET_67.mp4': 'https://stream.mux.com/awmbGE2f0100v019mhxSCXh8p2Q02RLTJkmp7101UabjlhHM.m3u8',
    'PHET_68.mp4': 'https://stream.mux.com/GAcvF94XEog4WL8IX00yrJkH59tNSLhNK7pt57wIKhRY.m3u8',
    'PHET_69.mp4': 'https://stream.mux.com/Xyr5bcZzNJmtpQSKJFTK02PqXB00AB4ay85g502gbLIePM.m3u8',
    'PHET_70.mp4': 'https://stream.mux.com/Vq2hT9jfp52AT3HTWxWjG3NfVrFJsNoWQhOfoaUP2K4.m3u8',
    'PHET_71_73.mp4': 'https://stream.mux.com/xc1iTWILSVjE6CRuHsu8duYPj2spzIil67SecRUReOI.m3u8',
    'PHET_74.mp4': 'https://stream.mux.com/u1ArW02016tTnacPwSUVWF9MSfdpbqAKY5pqdkFgpGsKs.m3u8',
    'Organization_PHET_75_76.mp4': 'https://stream.mux.com/3W601QcU8rurPEJ7P58XUuBBSymcbK02FyV00d602icH02AM.m3u8',
    'Organization_PHET_77_78.mp4': 'https://stream.mux.com/1Dmo2T4UnD2q1CLMLMmil5EunP679Gn5NZ3h02mmWvPg.m3u8',
    'PHET_79.mp4': 'https://stream.mux.com/AwaYxLk02PuSvNIXCQpXjtjibcJUJKUrLR02PneHpW2Pc.m3u8',
    'PHET_80_83.mp4': 'https://stream.mux.com/LZ3ZTLxaVAALHT9A9jfSqjNWipi9OtPRorj78iuCkZA.m3u8',
    'PHET_84_85.mp4': 'https://stream.mux.com/uu6ee7gqUPhlsPDDVHiq00rkP3xLpvT00HiuBeKiVg4ww.m3u8',
    'PHET_86_87.mp4': 'https://stream.mux.com/IzdBHmbXcnFb2EU01sOUx2upV006mrkRM24HSdxGnvCqw.m3u8',
    'PHET_88.mp4': 'https://stream.mux.com/lxkQuMFw02LBEddNESIBXp7zFJHHIedkS3A301MrMkayI.m3u8',
    'PHET_89_90.mp4': 'https://stream.mux.com/LMB5j8NPDxmdFFxZHq9hqDvz34eJRP4ScRhIWSs00KoE.m3u8',
    'PHET_92.mp4': 'https://stream.mux.com/5VxRNaNx0200e35KYpwCwy02pkT02U8XBMp1UuUuSEQ8YxE.m3u8',
    'PHET_93.mp4': 'https://stream.mux.com/FDgx9xifsyd6en3qOjj00lkycb1UWjF00o01zLwPX8h4C00.m3u8'
};
// NB: We removed what was originally session 1 and moved up other sessions by 1 position.
// That is why the video URLs dont match up exactly with session numbers. The S1/*_Revised
// videos came in after the renaming and were properly named by session number so that is
// why only those videos have the right session number in the url
var STATIC_SESSION_01 = {
    ID: 'understanding suicide',
    name: 'Understanding Suicide',
    description: 'Learn more about suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_1_211203.mp4'),
                title: 'Adults Over the Age of 45',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_2_211203.mp4'),
                title: 'American Indians',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_3_211203.mp4'),
                title: 'Alaskan Natives',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_4_211203.mp4'),
                title: 'Other Groups',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_5_211203.mp4'),
                title: 'SSRIs',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S1/Video_1_6_211203.mp4'),
                title: 'SNRIs',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_02 = {
    ID: 'suicide statistics',
    name: 'Suicide Statistics',
    description: 'Knowing the stats helps set context',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S2/Video_2_1_220110.mp4'),
                title: 'Suicide Stats by Age',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S2/Video_2_2_211206.mp4'),
                title: 'Suicide Stats by Ethnicity',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S2/Video_2_3_211206.mp4'),
                title: 'Suicide Stats by Method',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_03 = {
    ID: 'stress & suicide',
    name: 'Stress & Suicide',
    description: 'Stress is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S3/Video_3_1_211206.mp4'),
                title: 'Examples of Stress',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S3/Video_3_2_211206.mp4'),
                title: 'Stress and Genes',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_04 = {
    ID: 'depression & suicide',
    name: 'Depression & Suicide',
    description: 'Depression is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S4/Video_4_1_211206.mp4'),
                title: 'Types of Major Depression',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S4/Video_4_2_211206.mp4'),
                title: 'Symptoms of Depression',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_05 = {
    ID: 'anxiety & suicide',
    name: 'Anxiety & Suicide',
    description: 'Anxiety is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S5/Video_5_1_211207.mp4'),
                title: 'Types of Anxiety',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S5/Video_5_2_211207.mp4'),
                title: 'Symptoms of Anxiety',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_06 = {
    ID: 'chronic illness & suicide',
    name: 'Chronic Illness & Suicide',
    description: 'Chronic illness is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S6/Video_6_1_211207.mp4'),
                title: 'Types of Chronic Illness',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S6/Video_6_2_211207.mp4'),
                title: 'Symptoms of Chronic Illness',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_07 = {
    ID: 'cancer & suicide',
    name: 'Cancer & Suicide',
    description: 'Cancer is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S7/Video_7_1_211207.mp4'),
                title: 'Types of Cancer',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S7/Video_7_2_211207.mp4'),
                title: 'Symptoms of Cancer',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_08 = {
    ID: 'schizophrenia & suicide',
    name: 'Schizophrenia & Suicide',
    description: 'Schizophrenia is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S8/Video_8_1_211207.mp4'),
                title: 'Delusions',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S8/Video_8_2_211207.mp4'),
                title: 'Negative Symptoms of Schizophrenia',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_09 = {
    ID: 'addiction & suicide',
    name: 'Addiction & Suicide',
    description: 'Addiction is a risk factor of suicide',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S9/Video_9_1_211207.mp4'),
                title: 'Types of Addiction',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S9/Video_9_2_211207.mp4'),
                title: 'Symptoms of Addiction',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_10 = {
    ID: 'common warning signs',
    name: 'Common Warning Signs',
    description: 'Go over common warning signs again',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S10/Video_10_1_211207.mp4'),
                title: 'SSRIs',
                compulsory: true
            }
        },
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S10/Video_10_2_211207.mp4'),
                title: 'SNRIs',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_11 = {
    ID: 'common risk factors',
    name: 'Common Risk Factors',
    description: 'Review common risk factors',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S11/Video_11_1_211207.mp4'),
                title: 'Common Risk Factors',
                compulsory: true
            }
        }
    ]
};
var STATIC_SESSION_12 = {
    ID: 'suicide survival stats',
    name: 'Suicide Survival Stats',
    description: 'Statistics about suicide survival',
    items: [
        {
            __typename: 'LegacyQuizSetItemVideo',
            props: {
                url: getMuxUrlFromGCSUrl('https://storage.googleapis.com/asset.oui.dev/voiceover/static/S12/Video_12_1_211207.mp4'),
                title: 'Suicide Stats by Age',
                compulsory: true
            }
        }
    ]
};
var _obj;
export var STATIC_QUIZ_SET_DATA = (_obj = {}, _define_property(_obj, ContentType.STATIC_01, [
    STATIC_SESSION_01
]), _define_property(_obj, ContentType.STATIC_02, [
    STATIC_SESSION_02
]), _define_property(_obj, ContentType.STATIC_03, [
    STATIC_SESSION_03
]), _define_property(_obj, ContentType.STATIC_04, [
    STATIC_SESSION_04
]), _define_property(_obj, ContentType.STATIC_05, [
    STATIC_SESSION_05
]), _define_property(_obj, ContentType.STATIC_06, [
    STATIC_SESSION_06
]), _define_property(_obj, ContentType.STATIC_07, [
    STATIC_SESSION_07
]), _define_property(_obj, ContentType.STATIC_08, [
    STATIC_SESSION_08
]), _define_property(_obj, ContentType.STATIC_09, [
    STATIC_SESSION_09
]), _define_property(_obj, ContentType.STATIC_10, [
    STATIC_SESSION_10
]), _define_property(_obj, ContentType.STATIC_11, [
    STATIC_SESSION_11
]), _define_property(_obj, ContentType.STATIC_12, [
    STATIC_SESSION_12
]), _obj);
